import React from "react";
import classnames from "classnames";

import { Action, Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";
import isMobileDevice from "utils/isMobileDevice";

import ExpandableContainer from "components/botanic/ExpandableContainer";
import { FormattedText } from "components/FormattedText";

const AboutBrand = ({
  brandId,
  brandDescription,
  brandSpotlightVideoUrl,
}: {
  brandId: number;
  brandDescription: string;
  brandSpotlightVideoUrl: string | undefined;
}) => {
  const { publishEvent } = useEventTracker();
  // You must have a brand description to show this section
  if (!brandDescription) {
    return null;
  }

  const hasVideo = brandSpotlightVideoUrl;
  const isMobile = isMobileDevice();

  return (
    <>
      <h2 className="mb-sm heading--m">Our story</h2>
      <div className="md:flex md:flex-wrap" data-testid="about-brand">
        <div
          className={classnames("w-full md:w-1/2", {
            "md:w-full": !hasVideo,
          })}
        >
          <ExpandableContainer
            autoHide
            initialHeight={isMobile ? "360px" : "269px"}
            showLessText="read less"
            showMoreText="read more"
            onButtonClick={() => {
              publishEvent({
                action: Action.click,
                brandId: brandId,
                category: Category.brandPaid,
                label: "brand story",
              });
            }}
          >
            <FormattedText text={brandDescription} />
          </ExpandableContainer>
        </div>
        {hasVideo && (
          <div className="pt-xxl md:pt-0 md:ml-xl md:pb-xl">
            <iframe
              src={brandSpotlightVideoUrl}
              title="Brand spotlight video"
              className="w-full h-[185px] md:w-[470px] md:h-[270px] mt-xs"
            ></iframe>
            <p className="text-xs text-center pt-xs md:mb-0">
              Brand spotlight video
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default AboutBrand;
